/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
const template = html`
    <style include="app-styles">
      paper-card {
        height: fit-content !important;
        padding:24px 10% 10%;
      }
      paper-checkbox .selection-checkbox {
        --paper-checkbox-label-spacing: 0;
        --paper-checkbox-checked-color: #3CB371;
      }
      .list-search{
        padding: 0 0px 20px 0px;
      }
      .listing-filter-actions {
        padding: 0px 24px 24px;
      }
      .font-style {
        letter-spacing: 0.0025em;
      }
      .heading-sub-font {
        padding: 0px 24px 24px;
      }
      .font-color{
        color: rgb(0, 131, 155);
      }
    </style>
    <oe-ajax id="fetchOpenBankingAccounts" url="/api/CBUsers/{{userId}}/customopenbanking-fetchaccountconsent-request" on-response="_openBankingAccountConsentResponse" on-error="_openBankingAccountConsentError"></oe-ajax>
    <oe-ajax id="fetchOpenBankingConsents" url="/api/CBUsers/{{userId}}/customopenbanking-consent-request?filter[where][consentId]={{consentId}}" on-response="_openBankingConsentsResponse" on-error="_openBankingConsentsResponseError"></oe-ajax>
    <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}" notsupporteddevice={{notsupporteddevice}}></app-media-query>
    <page-title name="h_CorporateDashboard" left-action="{{leftAction}}"></page-title>
    <div class="content-align-center">
      <div class="margin-b-zero mdl-cell mdl-cell--10-col">
        <paper-card>
          <div class="mdl-grid mdl-grid--no-spacing" style="margin: 24px 24px;">
            <div class="mdl-cell mdl-cell--12-col" style="padding-bottom: 10px"> 
                <div class="font-style font-30">
                    <oe-i18n-msg msgid="l_SelectAccount" role="heading" aria-level="1"></oe-i18n-msg>
                </div>
            </div>
            <div class="mdl-cell mdl-cell--12-col">
                <div class="font-style font-16 font-color">
                    <oe-i18n-msg msgid="l_tppRequestText" role="heading" aria-level="1"></oe-i18n-msg>
                </div>
            </div>
          </div>
          <div class="listing-table-container" style="border:2px solid #f6f8f9;border-radius: 5px;">
              <div class="mdl-grid mdl-grid--no-spacing" style="margin: 24px 24px;">
                  <div class="mdl-cell mdl-cell--12-col">
                      <div class="font-style font-24">
                          <oe-i18n-msg msgid="l_accountList" role="heading" aria-level="1"></oe-i18n-msg>
                      </div>
                  </div>
              </div>
              <div class="border-b-1px horizontal layout main-tabs">
                <paper-tabs style = "margin-left:3.3%;" selected={{selectedAccountsTab}}>
                    <paper-tab class="tab-content font-18 paddingClass1" hidden$="{{!validateDeepMenuAccessConsent('CORPACCTS')}}">
                        <iron-icon id="register" icon="accounts" ></iron-icon>&nbsp;
                        <oe-i18n-msg msgid="h_Accounts" id="corporate-cash-position-accounts-tab" class="headerTabClass"></oe-i18n-msg>
                    </paper-tab>
                    <paper-tab class="tab-content font-18 paddingClass2" hidden$="{{!validateDeepMenuAccessConsent('CORPACCTS')}}">
                        <iron-icon id="register" icon="accounts" ></iron-icon>&nbsp;
                        <oe-i18n-msg msgid="l_DepositAccounts" id="corporate-cash-position-cards-tab" class="headerTabClass"></oe-i18n-msg>
                    </paper-tab>
                    <paper-tab class="tab-content font-18 paddingClass2" hidden$="{{!validateDeepMenuAccessConsent('ACCCARDS')}}">
                        <iron-icon id="register" icon="credit-card-new" ></iron-icon>&nbsp;
                        <oe-i18n-msg msgid="l_Creditcards" id="corporate-cash-position-my-views-tab" class="headerTabClass"></oe-i18n-msg>
                    </paper-tab>
                    <paper-tab class="tab-content font-18 paddingClass2" hidden$="{{!validateDeepMenuAccessConsent('ACCCARDS')}}">
                        <iron-icon id="register" icon="credit-card-new" ></iron-icon>&nbsp;
                        <oe-i18n-msg msgid="h_PrepaidCard" id="corporate-cash-position-my-views-tab" class="headerTabClass"></oe-i18n-msg>
                    </paper-tab>
                    <paper-tab class="tab-content font-18 paddingClass2" hidden$="{{!validateDeepMenuAccessConsent('ACCLOANS')}}">
                        <iron-icon id="register" icon="loans" ></iron-icon>&nbsp;
                        <oe-i18n-msg msgid="h_LoanAccs" id="corporate-cash-position-my-views-tab" class="headerTabClass"></oe-i18n-msg>
                    </paper-tab>
                </paper-tabs>
              </div>
              <div class="mdl-grid  mdl-grid--no-spacing">
                <div class="mdl-cell mdl-cell--8-col-tablet mdl-cell--12-col">
                  <iron-pages selected="{{selectedAccountsTab}}">
                    <div>
                      <template is="dom-if" if="{{validateDeepMenuAccessConsent('CORPACCTS')}}" restamp="true">
                        <open-banking-account-common-listing accounts-list={{operativeAccountsList}} selected-account-list={{selectedAccountList}} accounts-list-loaded={{accountsListLoaded}}></open-banking-account-common-listing>
                      </template>
                    </div>
                    <div>
                      <template is="dom-if" if="{{validateDeepMenuAccessConsent('CORPACCTS')}}" restamp="true">
                        <open-banking-account-common-listing accounts-list={{depositAccountsList}} selected-account-list={{selectedAccountList}} accounts-list-loaded={{accountsListLoaded}}></open-banking-account-common-listing>
                      </template>
                    </div>
                    <div>
                      <template is="dom-if" if="{{validateDeepMenuAccessConsent('ACCCARDS')}}" restamp="true">
                        <open-banking-account-common-listing accounts-list={{creditCardsList}} selected-account-list={{selectedAccountList}} accounts-list-loaded={{accountsListLoaded}}></open-banking-account-common-listing>
                      </template>
                    </div>
                    <div>
                      <template is="dom-if" if="{{validateDeepMenuAccessConsent('ACCCARDS')}}" restamp="true">
                        <open-banking-account-common-listing accounts-list={{prepaidCardsList}} selected-account-list={{selectedAccountList}} accounts-list-loaded={{accountsListLoaded}}></open-banking-account-common-listing>
                      </template>
                    </div>
                    <div>
                      <template is="dom-if" if="{{validateDeepMenuAccessConsent('ACCLOANS')}}" restamp="true">
                        <open-banking-account-common-listing accounts-list={{loanAccountsList}} selected-account-list={{selectedAccountList}} accounts-list-loaded={{accountsListLoaded}}></open-banking-account-common-listing>
                      </template>
                    </div>
                  </iron-pages>
                </div>
              </div>
              <template is="dom-if" if="{{openBankingConsentResponse.accountConsent.permission.length}}">
                <div class="mdl-grid mdl-grid--no-spacing" style="margin: 24px 24px;">
                  <div class="mdl-cell mdl-cell--12-col">
                      <div class="font-style font-16 font-color">
                          <oe-i18n-msg msgid="l_viewDataSharing" role="heading" aria-level="1"></oe-i18n-msg>
                      </div>
                  </div>
                </div>
                <div class="listing-table-container" style="border-radius: 5px;">
                    <template is = "dom-repeat" items="{{openBankingConsentResponse.accountConsent.permission}}">
                        <div class="action-button-wrapper listing-items overflow-hidden mainContainer list" tabindex="0"  style="margin-bottom:1px">
                            <div class$=" openedItem-{{item.openedFlag}} mdl-cell mdl-cell--12-col horizontal light-background layout list-item content-align-vertical-center " style="padding:1.2%;margin:0px 0px 1px 0px;width:-webkit-fill-available;background:#eaf0f5;">
                                <div class="mdl-cell mdl-cell--12-col-desktop acct-list-value-class wrapClass1" role="cell">
                                    {{item.codeDescription}}
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
              </template>
              <template is="dom-if" if="{{openBankingConsentResponse.transactionToDate}}">
                <div class="mdl-grid mdl-grid--no-spacing" style="margin: 24px 10px;">
                  <div class="mdl-cell mdl-cell--12-col">
                      <div class="font-style font-14 font-color">
                          <div>{{getExpiryLabel()}}</div>
                      </div>
                  </div>
                </div>
              </template>
              <div class="mdl-cell--12-col horizontal layout content-align-horizontal-end" tabindex="0" style="padding:2% 0px 10;">
                <div class="mdl-cell--2-col" style="width: auto; margin-right: 16px;"> 
                  <paper-button raised class="secondary-medium-button" on-tap="_proceedToDeclineConsent" elevation="0" style="width:-webkit-fill-available;">
                      <oe-i18n-msg msgid="b_decline"></oe-i18n-msg>
                  </paper-button>
                </div>
                <div class="mdl-cell--3-col">
                    <paper-button id="proceed" raised class="primary-medium-button" on-tap="_proceedToPatchConsent" style = "width:-webkit-fill-available;">
                        <oe-i18n-msg msgid="b_Proceed"></oe-i18n-msg>
                    </paper-button>
                </div>
            </div>
        </paper-card>
      </div>
    </div>
    `;
Polymer({
  is: 'open-banking-account-consents-listing',
  _template: template,
  behaviors: [corpBehaviours.appCommonBehaviour, corpBehaviours.appMenuBehaviour, corpSbBehaviour.corpAuthAndWorkflow],
  properties: {
    selectedPage: {
      type: String,
      value: 0,
      notify: true
    },
    openBankingAccountsResponse: {
      type: Array,
      notify: true,
      value: []
    },
    openBankingConsentResponse: {
      type: Object,
      notify: true
    },
    userId: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'userId');
      }
    },
    accountsListLoaded: {
      type: Boolean,
      value: false
    },
    displayRows: {
      type: Array,
      notify: true
    },
    consentId: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'openBankingConsentId');
      }
    },
    filterVal: {
      type: String,
      value: ""
    },
    filterTransactions: {
      type: Array,
      notify: true,
      value: ['accountName', 'accountId', 'accountType.codeDescription']
    },
    selectedAccountList: {
      type: Array,
      value: [],
      notify: true
    },
    accountPermissionList: {
      type: Array,
      value: []
    },
    responseObject: {
      type: Object,
      notify: true
    },
    body: {
      type: Object,
      notify: true
    },
    actionType: {
      type: String,
      notify: true
    },
    selectedAccountsTab: {
      type: Number,
      notify: true,
      value: 0
    },
    operativeAccountsList: {
      type: Array,
      value: [],
      notify: true
    },
    depositAccountsList: {
      type: Array,
      value: [],
      notify: true
    },
    creditCardsList: {
      type: Array,
      value: [],
      notify: true
    },
    prepaidCardsList: {
      type: Array,
      value: [],
      notify: true
    },
    loanAccountsList: {
      type: Array,
      value: [],
      notify: true
    }
  },
  ready() {
    this.fire('stop-processing-loader');
    if (this.validateDeepMenuAccessConsent('CORPACCTS')) {
      this.selectedAccountsTab = 0;
    }
    else if (this.validateDeepMenuAccessConsent('ACCCARDS')) {
      this.selectedAccountsTab = 2;
    }
    else if (this.validateDeepMenuAccessConsent('ACCLOANS')) {
      this.selectedAccountsTab = 4;
    }
    this.$.fetchOpenBankingAccounts.generateRequest();
    this.$.fetchOpenBankingConsents.generateRequest();
  },
  _openBankingAccountConsentResponse(event) {
    var operativeAccountsList = [];
    var depositAccountsList = [];
    var creditCardsList = [];
    var prepaidCardsList = [];
    var loanAccountsList = [];
    var openBankingAccountsResponse = event.detail.response;
    openBankingAccountsResponse.forEach(element => {
      if (element.parentAccountType.cmCode == "OPR") {
        if (element.accountType.cmCode !== "VOS") {
          operativeAccountsList.push(element);
        }
      }
      if (element.parentAccountType.cmCode == "DEP") {
        depositAccountsList.push(element);
      }
      if (element.parentAccountType.cmCode == "LON") {
        loanAccountsList.push(element);
      }
      if (element.parentAccountType.cmCode == "CCD" && element.accountType.cmCode == "CCD") {
        creditCardsList.push(element);
      }
      if (element.parentAccountType.cmCode == "CCD" && element.accountType.cmCode == "PCD") {
        prepaidCardsList.push(element);
      }
    });
    this.operativeAccountsList = operativeAccountsList;
    this.depositAccountsList = depositAccountsList;
    this.creditCardsList = creditCardsList;
    this.prepaidCardsList = prepaidCardsList;
    this.loanAccountsList = loanAccountsList;

    this.openBankingAccountsResponse = event.detail.response;
    this.accountsListLoaded = true;
  },
  _openBankingConsentsResponse(event) {
    var self = this;
    this.openBankingConsentResponse = event.detail.response;
    this.openBankingConsentResponse.accountConsent.permission.forEach(element => {
      self.accountPermissionList.push(element.cmCode)
    });
  },
  _openBankingAccountConsentError(event) {
    showAjaxError(event);
    this.accountsListLoaded = false;
    var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
    var headers = convertedArr.reduce(function (each, current, i) {
      var parts = current.split(': ');
      each[parts[0]] = parts.slice(1).join();
      return each;
    }, {});
    if (headers.channelcontext) {
      var messageToDisplay = "";
      var channelcontext = JSON.parse(headers.channelcontext);
      var msgList = [];
      if (channelcontext.status.message && channelcontext.status.message.length > 1) {
        for (i = 0; i < channelcontext.status.message.length; i++) {
          msgList.push(channelcontext.status.message[i].messageDesc);
        }
        messageToDisplay = msgList[0];
      }
      else if (channelcontext.status.message) {
        messageToDisplay = channelcontext.status.message[0].messageDesc;
      }
    }
    setTimeout(() => {
      if (clientStorage.get(storageType.session, 'backendRedirectUri')) {
        var redirectUrl = clientStorage.get(storageType.session, 'backendRedirectUri') + "?status=FAL" + "&state=" + clientStorage.get(storageType.session, 'openBankingState') + "&event=" + messageToDisplay;
        window.location.href = redirectUrl;
      }
    }, 5000);
  },
  _openBankingConsentsResponseError(event) {
    showAjaxError(event);
    var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
    var headers = convertedArr.reduce(function (each, current, i) {
      var parts = current.split(': ');
      each[parts[0]] = parts.slice(1).join();
      return each;
    }, {});
    if (headers.channelcontext) {
      var messageToDisplay = "";
      var channelcontext = JSON.parse(headers.channelcontext);
      var msgList = [];
      if (channelcontext.status.message && channelcontext.status.message.length > 1) {
        for (i = 0; i < channelcontext.status.message.length; i++) {
          msgList.push(channelcontext.status.message[i].messageDesc);
        }
        messageToDisplay = msgList[0];
      }
      else if (channelcontext.status.message) {
        messageToDisplay = channelcontext.status.message[0].messageDesc;
      }
    }
    setTimeout(() => {
      if (clientStorage.get(storageType.session, 'backendRedirectUri')) {
        var redirectUrl = clientStorage.get(storageType.session, 'backendRedirectUri') + "?status=FAL" + "&state=" + clientStorage.get(storageType.session, 'openBankingState') + "&event=" + messageToDisplay;
        window.location.href = redirectUrl;
      }
    }, 5000);
  },
  getExpiryLabel() {
    return getLabel("l_accountAccessExpiry") + this.formatDate(this.openBankingConsentResponse.transactionToDate);
  },
  formatDate: function (date) {
    return moment.utc(date).format('DD-MMM-YYYY');
  },
  _checkUncheck: function (e) {
    var index = e.model.__data.index;
    var accountId = this.displayRows[index].accountId;
    if (e.currentTarget.checked) {
      this.set('displayRows.' + index + '.selected', true);
      this.selectedAccountList.push(accountId);
    } else {
      if (this.selectedAccountList.length > 0) {
        this.selectedAccountList.forEach((item, index) => {
          if (item == accountId) {
            this.selectedAccountList.splice(index, 1);
          }
        });
      }
      this.set('displayRows.' + index + '.selected', false);
    }
    e.stopPropagation();
  },
  _proceedToPatchConsent() {
    this.actionType = "APPROVE";
    if (_.isEmpty(this.selectedAccountList)) {
      this.fire('oe-show-error', getLabel("l_PleaseSelectRecords"));
      return;
    }
    var url = "/api/CBUsers/" + this.userId + "/customopenbanking-consent-request";
    var method = "POST";
    var transactionType = "OPC";
    this.body = this.getRequestBody("APPROVE");
    this.submitNonFinancialDetails(url, method, this.body, "", transactionType, "");
  },
  _proceedToDeclineConsent() {
    this.actionType = "DECLINE";
    var url = "/api/CBUsers/" + this.userId + "/customopenbanking-consent-request";
    var method = "POST";
    var transactionType = "OPC";
    this.body = this.getRequestBody("DECLINE");
    this.submitNonFinancialDetails(url, method, this.body, "", transactionType, "");
  },
  getRequestBody(actionType) {
    var body = {
      "consentId": this.openBankingConsentResponse.consentId,
      "sessionId": clientStorage.get(storageType.session, 'openBankingSessionId'),
      "consentScope": clientStorage.get(storageType.session, 'openBankingScope'),
      "consentStatus": actionType,
      "consentCreationDateTime": moment.utc(this.openBankingConsentResponse.consentCreationDateTime).format("YYYY-MM-DDT00:00:00"),
      "statusUpdateDateTime": moment.utc(this.openBankingConsentResponse.statusUpdateDateTime).format("YYYY-MM-DDT00:00:00"),
      "corporateUser": this.openBankingConsentResponse.corporateUser,
      "updatedAt": moment.utc(this.openBankingConsentResponse.updatedAt).format("YYYY-MM-DDT00:00:00"),
      "consentLink": this.openBankingConsentResponse.consentLink,
      "transactionFromDate": moment.utc(this.openBankingConsentResponse.transactionFromDate).format("YYYY-MM-DDT00:00:00"),
      "transactionToDate": moment.utc(this.openBankingConsentResponse.transactionToDate).format("YYYY-MM-DDT00:00:00"),
      "accountIdList": this.selectedAccountList,
      "accountConsent": {
        "permission": this.accountPermissionList
      },
      "paymentConsent": {
        "readRefundAccount": "",
        "localInstrument": "",
        "endToEndIdentification": "",
        "instructedAmount": "",
        "instructedCurrecny": "",
        "schemeName": "",
        "creditorAccountId": "",
        "name": "",
        "reference": "",
        "unstructuredReference": ""
      },
      "tppDetails": {
        "clientId": this.openBankingConsentResponse.tppDetails.clientId,
        "clientOrgId": this.openBankingConsentResponse.tppDetails.clientOrgId,
        "statementId": this.openBankingConsentResponse.tppDetails.statementId,
        "tppName": this.openBankingConsentResponse.tppDetails.tppName
      }
    }
    return body;
  },
  _callWorkflowPage(event) {
    var tempObj = event.detail.request.__data.response.error.message;
    this.responseObject = tempObj;
    this.selectedPage = 1;
  },
  validateDeepMenuAccessConsent: function (menuKey) {
    if (menuKey) {
      var deepMenuConfigData = menuConfig;
      var deepMenuConfigObj = deepMenuConfigData.find(function (item) {
        return menuKey == item.menukey;
      });
      if (deepMenuConfigObj) {
        var menuProfileData = clientStorage.get(storageType.session, 'menuProfiles');
        if (this._ifEmptyString(deepMenuConfigObj.menuid) || (menuProfileData && menuProfileData.indexOf(deepMenuConfigObj.menuid) >= 0)) {
          return true;
        } else {
          return false;
        }
      }
      else {
        return false;
      }
    }
    return true;
  },
  _errorHandler(event) {
    showAjaxError(event);
    var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
    var headers = convertedArr.reduce(function (each, current, i) {
      var parts = current.split(': ');
      each[parts[0]] = parts.slice(1).join();
      return each;
    }, {});
    if (headers.channelcontext) {
      var messageToDisplay = "";
      var channelcontext = JSON.parse(headers.channelcontext);
      var msgList = [];
      if (channelcontext.status.message && channelcontext.status.message.length > 1) {
        for (i = 0; i < channelcontext.status.message.length; i++) {
          msgList.push(channelcontext.status.message[i].messageDesc);
        }
        messageToDisplay = msgList[0];
      }
      else if (channelcontext.status.message) {
        messageToDisplay = channelcontext.status.message[0].messageDesc;
      }
    }
    setTimeout(() => {
      if (clientStorage.get(storageType.session, 'backendRedirectUri')) {
        var redirectUrl = clientStorage.get(storageType.session, 'backendRedirectUri') + "?status=FAL" + "&state=" + clientStorage.get(storageType.session, 'openBankingState') + "&event=" + messageToDisplay;
        window.location.href = redirectUrl;
      }
    }, 5000);
  }
});
